import React, { useState } from "react";
import {
  Lightbulb,
  Cpu,
  Globe,
  Heart,
  Clock,
  Code,
  GraduationCap,
  Users,
  ArrowRight,
  Calendar,
  ExternalLink,
  FileText,
  ArrowUpRight,Sparkles,Compass,Award
} from "lucide-react";

import logo from "../src/img/mad1.png";
import ImpactCarousel from "./components/ImpactCarousel";
import EventInfo from "./components/EventInfo";
import Objetivos from "./components/Objetivos";
import Actividades from "./components/Actividades";
import { motion } from "framer-motion";
import interfacultades from "../src/img/interfacultades.pdf";
import interuniversidades from "../src/img/interuniversidades.pdf";
import EventoDebateUTPL from "./components/EventoDebateUTPL";
const App = () => {
  const [activeDay, setActiveDay] = useState(1);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Datos extraídos del documento adjunto
  const lines = [
    {
      title: "Innovación en educación a distancia",
      desc: "Presentación de buenas prácticas y proyectos de innovación enfocados a analizar: modelos pedagógicos, metodologías activas, uso de tecnología y experiencias innovadoras en educación en línea.",
      icon: <Lightbulb size={32} />,
    },
    {
      title: "Inclusión y democratización del acceso a la educación superior",
      desc: "Socialización de experiencias que promuevan el acceso a la educación para poblaciones diversas y territorios alejados.",
      icon: <Cpu size={32} />,
    },
    {
      title: "Impacto social de la educación a distancia",
      desc: "Presentación de experiencias sobre el impacto de la modalidad a distancia y en línea en el desarrollo personal, profesional y comunitario de los Alumni UTPL.",
      icon: <Globe size={32} />,
    },
    {
      title: "Emprendimiento e innovación estudiantil",
      desc: "Fortalecimiento de la competencia emprendedora para estudiantes y docentes por medio de su participación en proyectos que impulsen la creatividad, el emprendimiento y la generación de soluciones para los retos de la educación en línea.",
      icon: <Heart size={32} />,
    },
  ];
  const days = [
    { id: 1, label: "Día 1: Inauguración " },
    { id: 2, label: "Día 2: Comunidad, innovación y futuro" },
 
  ];

const agenda = {
  1: [
    {
      time: "08:30 - 09:00",
      event: "Registro",
      type: "Acceso",
    },
    {
      time: "09:00 - 09:30",
      event: "Acto inaugural: Inauguración edificio 10 y Conmemoración de los 50 años de educación a distancia en la UTPL",
      speaker: "Dr. Santiago Acosta",
      type: "Inauguración",
    },
    {
      time: "09:30 - 10:30",
      event: "Conferencia magistral",
      speaker: "Por definir",
      moderator: "Por definir",
      type: "Conferencia",
    },
    {
      time: "10:30 - 12:00",
      event: "Recorrido por las instalaciones del edificio 10. Zonas interactivas: recorrido tecnológico. Coffee break",
      type: "Experiencia",
    },
    {
      time: "12:00 - 15:00",
      event: "Almuerzo",
      type: "Networking",
    },
    {
      time: "15:00 - 16:00",
      event: "Conferencia magistral: El futuro de la educación",
      speaker: "Ph. D. Albert Sangrà Morer, Catedrático Universidad Oberta de Catalunya",
      moderator: "Dr. Artieres Romeiro",
      type: "Conferencia",
    },
    {
      time: "16:00 - 18:00",
      event: "Innova Docentes Inter facultades",
      type: "Innovación",
    },
    {
      time: "20:00 - 21:00",
      event: 'Obra de teatro: Viajeros en el tiempo "Historia de los 50 años de la MAD UTPL"',
      type: "Cultural",
    },
  ],

  2: [
    {
      time: "08:00 - 09:00",
      event: "Eucaristía de Acción de Gracias",
      
      type: "Eucaristía",
    },
    {
      time: "09:00 - 10:00",
      event: "Reconocimiento a aliados estratégicos",
      moderator: "Dr. Leonardo Izquierdo",
      type: "Panel", // Se mantiene o adapta según preferencia
    },
    {
      time: "10:00 - 10:30",
      event: "Coffee break",
      type: "Networking",
    },
    {
      time: "10:30 - 13:00",
      event: "Inno Docentes Inter Universitario e Inter Facultades",
      type: "Innovación",
    },
    {
      time: "08:00 - 18:00", // Unificado según la indicación de jornada partida (08:00 a 13:00 - 14:00 a 18:00)
      event: "Zonas interactivas: recorrido tecnológico",
      type: "Experiencia",
    },
    {
      time: "13:00 - 14:30",
      event: "Almuerzo",
      type: "Networking",
    },
    {
      time: "14:30 - 15:30",
      event: 'Legado que trasciende: "Historias que inspiran, huellas que perduran"',
      type: "Historias",
    },
    {
      time: "15:30 - 16:30",
      event: 'Ser "+", historias que trascienden fronteras',
      type: "Historias",
    },
    {
      time: "16:30 - 17:30",
      event: "Debate: 50 años ofertando Educación a Distancia y transformando vidas",
      type: "Debate",
    },
    {
      time: "17:30 - 18:00",
      event: "Premiación y cierre",
      type: "Cierre",
    },
    {
      time: "18:00 - 22:00",
      event: "Noche cultural: UTPL Fest",
      type: "Cultural",
    },
  ],
 
};

  return (
    <div className="min-h-screen bg-white">
      {/* Header / Nav */}

      {/* Hero */}
      <section id="inicio" className="relative pt-40 pb-24 overflow-hidden">
        <div className="hero-shape"></div>
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <motion.img
                src={logo}
                alt="utpl"
                className="h-auto w-40 mb-4"
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              />
            </div>
            <h1 className="text-6xl md:text-6xl  font-bold text-[#004270] leading-[0.95] tracking-tight">
              Innovación que{" "}
              <span className="text-[#febe10] font-black md:text-7xl">
                conecta
              </span>
              , educación que{" "}
              <span className="text-[#febe10] font-black md:text-7xl">
                transforma.
              </span>
            </h1>
            <p className="text-xl text-slate-500 max-w-lg leading-relaxed">
              El congreso conmemora los 50 años de educación a distancia de la
              UTPL, un encuentro para rediseñar el futuro de la educación
              superior en Latinoamérica.
            </p>
          </div>

          <div className="relative  ">
            <ImpactCarousel></ImpactCarousel>
          </div>
        </div>
      </section>
      <div className="pb-24">
        <EventInfo></EventInfo>
      </div>
      <section className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-5xl mx-auto">
          {/* Encabezado de la sección */}
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Inscríbete ahora
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              Selecciona tu categoría y asegura tu cupo en el evento.
            </p>
          </div>

          {/* Contenedor de Tarjetas */}
          <div className="grid md:grid-cols-2 gap-8 items-stretch">
            {/* Tarjeta: Comunidad UTPL */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 flex flex-col justify-between relative overflow-hidden transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center justify-between mb-6">
                  <span className="p-3 bg-blue-50 text-blue-600 rounded-xl">
                    <GraduationCap className="h-6 w-6" />
                  </span>
                  <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
                    Interno
                  </span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Comunidad UTPL
                </h3>
                <p className="text-sm text-gray-500 mb-6">
                  Docentes, administrativos y estudiantes vigentes.
                </p>

                <div className="flex items-baseline mb-8">
                  <span className="text-4xl font-extrabold text-gray-900">
                    Sin costo
                  </span>
                </div>
              </div>

              <div>
                {/* Botón Estado: Próximamente */}
            
                  <a
                  href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=qknrbm1D5kO-zbvfeeUHfXQqUup4lq5DkK8ZMnAo__pUMDBKNTVMSUM0SE0wVklQOThZUk9KUTNWQi4u&route=shorturl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-amber-50  border-amber-200 text-amber-800   rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-sm font-semibold shadow-sm transition-colors duration-200 group"
                >
                  <span>Inscríbete ahora</span>
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              </div>
            </div>

            {/* Tarjeta: Participantes Externos */}
            <div className="bg-white rounded-2xl border-2 border-blue-600 shadow-xl p-8 flex flex-col justify-between relative overflow-hidden transition-all duration-300 hover:scale-[1.01]">
              {/* Tag destacado */}
              <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl uppercase tracking-wider">
                Abiertas
              </div>

              <div>
                <div className="flex items-center justify-between mb-6">
                  <span className="p-3 bg-blue-50 text-blue-600 rounded-xl">
                    <Users className="h-6 w-6" />
                  </span>
                  <span className="bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
                    Público General
                  </span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Participantes Externos
                </h3>
                <p className="text-sm text-gray-500 mb-6">
                  Profesionales, graduados de otras instituciones y público en
                  general.
                </p>

                <div className="flex items-baseline mb-8">
                  <span className="text-sm font-semibold text-gray-500 mr-1">
                    USD
                  </span>
                  <span className="text-5xl font-extrabold text-gray-900">
                    50
                  </span>
                </div>
              </div>

              <div>
                {/* Botón de Pago / Registro */}
                <a
                  href="https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIk1BRDAiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTU4Iiwibm9tYnJlQ3Vyc28iOiAiQ09OR1JFU08gNTAgQcORT1MgTUFEIiwic29icmVwYXNhckN1cG9zIjogIk4ifQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-sm font-semibold shadow-sm transition-colors duration-200 group"
                >
                  <span>Registrarse y Pagar</span>
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="objetivos">
        <Objetivos></Objetivos>
      </section>

      <section id="actividades">
        <Actividades></Actividades>
        {/* Stats */}
      </section>

      <section className="bg-white py-16 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-6xl mx-auto">
          {/* Encabezado Principal */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <Lightbulb className="h-4 w-4 text-amber-500 animate-pulse" />
              <span>Convocatorias 2026</span>
            </div>
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl tracking-tight">
              Innova Docentes
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
              Experiencias innovadoras desarrolladas por docentes y estudiantes
              en educación en línea.
            </p>
          </div>

          {/* Contenedor de Convocatorias */}
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            {/* Convocatoria 1: Inter Universitarios */}
            <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8 flex flex-col justify-between transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="p-3 bg-blue-600 text-white rounded-xl shadow-sm">
                    <Globe className="h-6 w-6" />
                  </span>
                  <div>
                    <span className="text-xs font-semibold text-blue-600 uppercase tracking-wider">
                      Convocatoria Nacional
                    </span>
                    <h3 className="text-xl font-bold text-gray-900">
                      Inter Universitarios
                    </h3>
                  </div>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Busca contribuir a la mejora de los procesos de
                  enseñanza-aprendizaje mediante la incorporación de
                  metodologías activas, tecnologías educativas, estrategias de
                  evaluación, inclusión, interdisciplinariedad, sostenibilidad y
                  evidencias de impacto académico.
                </p>

                <div className="bg-white rounded-xl p-4 border border-gray-100 mb-6">
                  <p className="text-xs font-semibold text-gray-400 uppercase mb-2">
                    Dirigido a:
                  </p>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    Docentes que cuenten con experiencias implementadas y
                    documentadas, cuyos resultados puedan ser compartidos como
                    referentes de innovación educativa para la comunidad
                    académica nacional.
                  </p>

                
                </div>
              </div>
<a
  href={interuniversidades}
  target="_blank"
  rel="noopener noreferrer"
  className="
    inline-flex
    items-center
    rounded-xl
    border
    border-red-700
    px-5
    py-3
    font-semibold
    text-red-700
    transition-all
    duration-200
    hover:bg-red-700
    hover:text-white
  "
>
  📄 Bases de la Convocatoria
</a>
              {/* Footer de la tarjeta: Fechas y Enlaces */}
              <div className="space-y-4 pt-4 border-t border-gray-200/60">
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <Calendar className="h-4 w-4 text-blue-600" />
                  <span>
                    Postulación hasta:{" "}
                    <strong className="text-gray-900">
                      26 de julio de 2026
                    </strong>
                  </span>
                </div>

                <div className="grid sm:grid-cols-2 gap-3">
              

                  {/* Link de Inscripción */}
                  <a
                    href="https://forms.gle/TJNAfV55j8EwMZTD8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 px-4 rounded-xl text-sm shadow-sm transition-colors duration-200 group"
                  >
                    <span>Inscribirse aquí</span>
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </div>
            </div>

            {/* Convocatoria 2: Inter Facultades - Personal UTPL */}
            <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8 flex flex-col justify-between transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="p-3 bg-amber-500 text-white rounded-xl shadow-sm">
                    <GraduationCap className="h-6 w-6" />
                  </span>
                  <div>
                    <span className="text-xs font-semibold text-amber-600 uppercase tracking-wider">
                      Convocatoria Interna
                    </span>
                    <h3 className="text-xl font-bold text-gray-900">
                      Inter Facultades
                    </h3>
                  </div>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Busca reconocer, visibilizar y proyectar las experiencias de
                  innovación educativa desarrolladas por docentes de las
                  diferentes facultades, carreras y departamentos académicos de
                  la universidad.
                </p>


                <div className="bg-white rounded-xl p-4 border border-gray-100 mb-6">
                  <p className="text-xs font-semibold text-gray-400 uppercase mb-2">
                    Dirigido a:
                  </p>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    Personal docente de la UTPL (de todas las facultades,
                    modalidades y centros) que lidere o colabore en prácticas
                    transformadoras dentro del ecosistema institucional.
                  </p>
                </div>
              </div>
<a
  href={interfacultades}
  target="_blank"
  rel="noopener noreferrer"
  className="
    inline-flex
    items-center
    rounded-xl
    border
    border-red-700
    px-5
    py-3
    font-semibold
    text-red-700
    transition-all
    duration-200
    hover:bg-red-700
    hover:text-white
  "
>
  📄 Bases de la Convocatoria
</a>
              {/* Footer de la tarjeta: Fechas y Enlaces */}
              <div className="space-y-4 pt-4 border-t border-gray-200/60">
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <Calendar className="h-4 w-4 text-amber-500" />
                  <span>
                    Postulación hasta:{" "}
                    <strong className="text-gray-900">
                      26 de julio de 2026
                    </strong>
                  </span>
                </div>

                <div className="grid sm:grid-cols-2 gap-3">
               

                  {/* Link de Inscripción */}
                  <a
                    href="https://forms.cloud.microsoft/r/wGG51mqycu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold py-2.5 px-4 rounded-xl text-sm shadow-sm transition-colors duration-200 group"
                  >
                    <span>Inscripción UTPL</span>
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* Lines */}
      <section id="lineas" className="py-32 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-end justify-between mb-20 gap-8">
            <div className="max-w-2xl space-y-4">
              <h2 className="text-5xl font-black text-[#004270] tracking-tight">
                Líneas temáticas
              </h2>
              <p className="text-lg text-slate-500 font-medium italic">
                Ejes centrales de debate y aprendizaje colaborativo.
              </p>
            </div>
            <div className="w-32 h-2 bg-[#febe10] rounded-full hidden md:block"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
            {lines.map((line, i) => (
              <div
                key={i}
                className="line-card bg-white p-4 rounded-[2.5rem] flex flex-col items-center text-center"
              >
                <div className="w-16 h-16 bg-[#004270]/5 text-[#004270] rounded-2xl flex items-center justify-center mb-8">
                  {line.icon}
                </div>
                <h3 className="font-black text-[#004270] mb-4 text-lg leading-snug">
                  {line.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">
                  {line.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>


<EventoDebateUTPL></EventoDebateUTPL>
      {/* Agenda */}
      <section id="agenda" className="py-32">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center space-y-8 mb-20">
            <h2 className="text-5xl font-black text-[#004270]">
              Agenda del evento
            </h2>

            {days.map((day) => (
              <button
                key={day.id}
                onClick={() => setActiveDay(day.id)}
                className={`agenda-pill px-8 py-3 rounded-xl font-black text-sm ${
                  activeDay === day.id
                    ? "active"
                    : "text-slate-400 hover:text-[#004270]"
                }`}
              >
                {day.label}
              </button>
            ))}
          </div>

          <div className="space-y-6">
            {agenda[activeDay].map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-[2rem] border border-slate-100 flex flex-col md:flex-row md:items-center gap-8 hover:border-[#febe10] transition-all group shadow-sm"
              >
                <div className="flex items-center gap-4 w-48 flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-[#febe10]/10 flex items-center justify-center text-[#febe10] group-hover:bg-[#febe10] group-hover:text-[#004270] transition-colors">
                    <Clock size={18} />
                  </div>
                  <span className="font-black text-[#004270]">{item.time}</span>
                </div>
                <div className="flex-1">
                  <h4 className="font-extrabold text-slate-800 text-xl group-hover:text-[#004270] transition-colors">
                    {item.event}
                  </h4>

                  {item.speaker && (
                    <p className="mt-2 text-sm text-slate-600">
                      <span className="font-bold">Ponente:</span> {item.speaker}
                    </p>
                  )}

                  {item.moderator && (
                    <p className="text-sm text-slate-500">
                      <span className="font-bold">Moderador:</span>{" "}
                      {item.moderator}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Block */}
    </div>
  );
};

export default App;
